/**
 * section-story-slider.js
 *
 * Handles slide navigation for the Story Slider section.
 * Supports multiple independent instances on the same page.
 * Safe against duplicate script inclusion (data-initialized guard).
 * Keyboard accessible: ArrowLeft / ArrowRight when slider is focused.
 */

(function () {
  'use strict';

  function initSlider(slider) {
    var slides  = Array.from(slider.querySelectorAll('.story-slide'));
    var prevBtn = slider.querySelector('.story-slider__prev');
    var nextBtn = slider.querySelector('.story-slider__next');
    var countEl = slider.querySelector('.story-slider__count');

    if (!slides.length) return;

    var current = 0;
    var total   = slides.length;

    /* ── Update active slide and counter ── */
    function go(index) {
      /* Deactivate current */
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');

      /* Advance (wraps both ways) */
      current = ((index % total) + total) % total;

      /* Activate new */
      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');

      /* Update counter */
      if (countEl) {
        countEl.textContent = (current + 1) + ' / ' + total;
      }
    }

    /* ── Button listeners ── */
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        go(current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        go(current + 1);
      });
    }

    /* ── Keyboard support ── */
    slider.setAttribute('tabindex', '0');

    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        go(current - 1);
      }

      if (e.key === 'ArrowRight') {
        e.preventDefault();
        go(current + 1);
      }
    });

    /* ── Initialise counter display ── */
    if (countEl) {
      countEl.textContent = '1 / ' + total;
    }
  }

  /* ── Bootstrap all instances, guard against double-init ── */
  document.querySelectorAll('.story-slider:not([data-story-slider-init])').forEach(function (slider) {
    slider.setAttribute('data-story-slider-init', '');
    initSlider(slider);
  });

})();